import React from 'react';
import ReactDOM from 'react-dom';
import { IntlProvider } from "react-intl";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";

import * as serviceWorker from './serviceWorker';
import AppContext from './app-context'

import translations from "./i18n/locales";
import io from "socket.io-client";

type Dict = { [key: string]: { [key: string]: string } };

const locale: string = localStorage.getItem("locale") || "fr";
const messages: Dict = translations;
const msg = messages[locale];

Sentry.init({
  dsn: "https://61cf91d380384507872a9d78578cc49c@o44479.ingest.sentry.io/5575006",
  autoSessionTracking: true,
  integrations: [
    new Integrations.BrowserTracing(),
  ],
  environment: process.env.REACT_APP_ENV,
  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0,
});
const socket = io(`${process.env.REACT_APP_SOCKET_URL}`);

ReactDOM.render(
  <React.StrictMode>
    <IntlProvider locale={locale} key={locale} messages={msg}>
      <AppContext socket={socket} />
    </IntlProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
